import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {AuthEffects} from '@emm/auth/services/effects/auth.effects';
import {authFeatureKey, authReducer} from '@emm/auth/store/auth.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature(authFeatureKey, authReducer),
        EffectsModule.forFeature([AuthEffects])
    ],
    providers: [
        AuthFacadeService
    ]
})
export class AuthModule {}
